module.exports = __webpack_public_path__ + "assets/Jira.ecf5f49b.svg";